<template>
    <div
        :class="{'container section-spacing': !isEmbedded}">
        <hr 
            class="border-2 border-orange">
    </div>
</template>

<script>
export default {
    props: {
        isEmbedded: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    setup() {
        
    },
}
</script>